export default "__VITE_ASSET__BsKMebBL__"